import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import SelectComponent from '../Others/SelectComponent';
import TableComponent from '../Others/TableComponent';
import { typeHome } from '../../../Images/Images';
import { Singleton } from '../../../js/Singleton';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'

export default class DateTimeSelection extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    this.callbackList = ["00:00 am", "01:00 am", "02:00 am", "03:00 am", "04:00 am", "05:00 am", "06:00 am", "07:00 am", "08:00 am", "09:00 am", "10:00 am", "11:00 am",
      "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm", "07:00 pm", "08:00 pm", "09:00 pm", "10:00 pm", "11:00 pm"];
    var objCont = {};
    for (let i in this.callbackList) {
      objCont[this.callbackList[i]] = { array: [], expanded: true, totalCallback: 0 }
    }
    this.state = {
      hourSelected: "02",
      minuteSelected: "40",
      timeSelected: "PM",
      timeReturned: "14:40",
      selectedDate: moment(),
      dateReschedule: this.parseDate(new Date()),
      timeArrays: objCont,
    }
    this.dataSource = [];
    for (let i in this.props.dataSource) {
      let item = moment(this.props.dataSource[i].Day);
      this.dataSource.push(item);
    }
    this.minutes = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"];
    this.hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    this.time = ["AM", "PM"];
    this.timeScroll = "";
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.currentFocus = 0;
    this.canLoseFocus = false;
    this.daysAllowedforCallBack = this.sharedData.getGeneralPermissions()[35];
  }
  componentDidMount() {
    this.focusableItems = [this.refs["hourComponent"], this.refs["minuteComponent"], this.refs["secondComponent"], this.refs["buttonReady"]];
    var today = new Date();
    this.getCallBackByDay(this.parseDate(today));
  }
  getCallBackByDay(date) {
    let _this = this;
    let userId = this.sharedData.getParameters().UserID; //11;
    let objectResponseCallIcon = this.apiCont.getObjectResponse();
    this.apiCont.getDayCallBack(userId, date, objectResponseCallIcon);
    objectResponseCallIcon.onError = function (messageError) {
    };
    objectResponseCallIcon.onSuccess = function (objResponse) {
      var newCallBacks = _this.state.timeArrays;
      for (let obj in newCallBacks) {
        var objCont = newCallBacks[obj];
        objCont.array = [];
        objCont.totalCallback = 0;
        objCont.expanded = true;
      }
      for (let i in objResponse) {
        let resp = objResponse[i];
        var hour = parseInt(resp.Hour, 10);
        hour = (hour === 12 ? "12:00 pm" : (hour < 12 ? ('0' + hour).slice(-2) + ":00 am" : ('0' + (hour - 12)).slice(-2) + ":00 pm"));
        newCallBacks[hour].totalCallback = resp.CallBacks;
        for (let j in resp.Detail) {
          let det = resp.Detail[j]
          newCallBacks[hour].array.push({
            time: hour.replace("00", ('0' + det.Minute.toString()).slice(-2)),
            iconPhoneNumber: typeHome,
            phoneNumber: det.Telephone,
            campaign: det.Campaign
          });
        }
      }
      _this.setState({ timeArrays: newCallBacks })
    };
  }
  selectHour(hour) {
    this.setState({ hourSelected: hour.text });
    this.timeScroll = hour.text + ":00 " + this.state.timeSelected.toLowerCase();
    this.scrollToTime();
  }
  selectMinute(minute) {
    this.setState({ minuteSelected: minute.text });
  }
  selectTime(time) {
    this.setState({ timeSelected: time.text });
    this.timeScroll = this.state.hourSelected + ":00 " + time.text.toLowerCase();
    this.scrollToTime();
  }
  scrollToTime() {
    this.expandCallBack(this.timeScroll);
    let tScroll = this.refs[this.timeScroll];
    let _this = this;
    if (tScroll && tScroll.offsetTop) {
      setTimeout(() => { _this.refs["tableCallBack"].scrollTop = tScroll.offsetTop - tScroll.offsetHeight; }, 50);
    }
  }
  readyDateTimeReschedule(evt) {
    var hour24 = (this.state.timeSelected === "PM" && this.state.hourSelected !== "12" ? parseInt(this.state.hourSelected, 10) + 12 : this.state.hourSelected);
    if (this.state.timeSelected === "AM" && this.state.hourSelected === "12") {
      hour24 = "00"
    }
    let dateToSend = this.state.selectedDate ? this.state.dateReschedule : this.parseDate(new Date());
    let timeToSend = hour24 + ":" + this.state.minuteSelected;
    this.props.onSelectDate(dateToSend, timeToSend);
    evt.stopPropagation();
  }
  handleSelectDate(date) {
    var dateS = new Date(date);
    this.setState({
      dateReschedule: this.parseDate(dateS),
      selectedDate: date,
    });
    this.getCallBackByDay(this.parseDate(dateS));
  }
  parseDate(date) {
    // var options = {"month":"2-digit","year":"numeric","day":"2-digit"};
    // let dateLocale = date.toLocaleDateString("es-MX", options);
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    return year + "/" + month + "/" + day;
  }
  stopPropagation(evt) {
    this.canLoseFocus = true;
    evt.stopPropagation();
  }
  focusItem(item) {
    this.currentFocus = item;
  }
  blurItem(item) {
    this.currentFocus = ++this.currentFocus < this.focusableItems.length ? this.currentFocus : 0;
    this.focusableItems[this.currentFocus].focus();
  }
  expandCallBack(itemExpanded) {
    var array = this.state.timeArrays;
    if (array[itemExpanded].array.length > 0) {
      array[itemExpanded].expanded = !array[itemExpanded].expanded;
      this.setState({ timeArrays: array });
    }
  }
  render() {
    return (
      <div className="selectDateContainer" onClick={(e) => this.stopPropagation(e)}>
        <div className="dateContainer">
          <div className="calendarContainer">
            <DatePicker
              minDate={moment()}
              maxDate={moment().add(this.daysAllowedforCallBack, "days")}
              inline
              selected={this.state.selectedDate}
              locale={this.language.getText("CallControlcallCalificationlocale")}
              useWeekdaysShort={true}
              onChange={this.handleSelectDate.bind(this)}
              highlightDates={this.dataSource}
            />
          </div>
          <div className="selectHourContainer">
            <p className="timeSelectionTitle">{this.language.getText("CallControlcallCalificationhour") + ":"}</p>
            <div className="containerSeletcTime">
              <SelectComponent
                name={"hora"}
                ref={"hourComponent"}
                tabIndex="0"
                bottomBox={60}
                itemDefault={1}
                stylesSelector={{ height: 26, width: 20 }}
                displayer={"bigDisplayer"}
                customCell={"cellText"}
                dataSource={this.hours}
                onSelectItem={this.selectHour.bind(this)}
                onFocus={() => this.focusItem(0)} />
            </div>
            <p>:</p>
            <div className="containerSeletcTime">
              <SelectComponent
                name={"minuto"}
                ref={"minuteComponent"}
                tabIndex="1"
                bottomBox={60}
                itemDefault={40}
                stylesSelector={{ height: 26, width: 20 }}
                displayer={"bigDisplayer"}
                customCell={"cellText"}
                dataSource={this.minutes}
                onSelectItem={this.selectMinute.bind(this)}
                onFocus={() => this.focusItem(1)} />
            </div>
            <div className="containerSeletcTime">
              <SelectComponent
                name={"segundo"}
                ref={"secondComponent"}
                tabIndex="2"
                bottomBox={60}
                itemDefault={1}
                stylesSelector={{ height: 26, width: 20 }}
                displayer={"bigDisplayer"}
                customCell={"cellText"}
                dataSource={this.time}
                onSelectItem={this.selectTime.bind(this)}
                onFocus={() => this.focusItem(2)} />
            </div>
            <p className="buttonTime"
              onClick={(e) => this.readyDateTimeReschedule(e)}
              ref={"buttonReady"}
              tabIndex="3"
              onKeyPress={event => { if (event.key === 'Enter') { this.readyDateTimeReschedule(event) } }}
              onFocus={() => this.focusItem(3)}
              onBlur={() => this.blurItem(3)}>{this.language.getText("CallControlcallCalificationready")}</p>
          </div>
        </div>
        <div className="callBackList">
          <p className="titleCallBackList">
            {this.language.getText("CallControlcallCalificationcallbackG")}
          </p>
          <div className="tableCallBackList" ref="tableCallBack">
            {this.callbackList.map((item, i) =>
              <div className="containerCallBack" key={i + "time"} ref={item}>
                <div className={"timeHeader " + (this.state.timeArrays[item].array.length > 0 ? "cursor" : "")} onClick={() => this.expandCallBack(item)}>
                  <p className="timeHeaderText">{item}</p>
                  {this.state.timeArrays[item].totalCallback > 0 &&
                    <p className="timeHeaderCount">{this.state.timeArrays[item].totalCallback}</p>}
                </div>
                {this.state.timeArrays[item].expanded &&
                  <div className="tableContainer">
                    <TableComponent
                      customCell={"cellAssignedCallback"}
                      parameters={{ time: "time", iconPhoneNumber: "iconPhoneNumber", phoneNumber: "phoneNumber", campaignName: "campaign" }}
                      dataSource={this.state.timeArrays[item].array}
                      selectable={false}
                      selectedStyle={"none"}
                      cellHover={"none"}
                      orderBy={"phoneNumber"}
                      orderForm={true}
                      disabled={this.state.timeArrays[item].array.length > 0 ? false : true} />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/DateTimeSelection.jsx